import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SiteLayoutComponent } from "@platform-core/libraries/common/layout";
import { environment } from "../environments/environment";
declare function require(name: String) 
let productRouteConfig = require(`../assets/${environment.client_folder}/json/product-config.json`);

const routes: Routes = [
  {
    path: productRouteConfig["common"].route,
    // component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./common-features/common-features.module').then((m) => m.CommonFeaturesModule),
      },
    ],
  },
  {
    path: productRouteConfig["sbaloans"].route,
    // component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./sba-loans/sba-loans.module').then((m) => m.SbaLoansModule),
      },
    ],
  },
  {
    path: productRouteConfig["businessloans"].route,
    // component: SiteLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./business-loans/business-loans.module').then((m) => m.BusinessLoansModule),
      },
    ],
  },
  // ,
  // {
  //     path: "",
  //     redirectTo: "",
  //     pathMatch: "full",
  // },
  // {
  //     path: "**",
  //     redirectTo: "",
  //     pathMatch: "full"
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
